export default {
  BASE_SCREEN_WIDTH: 430,
  BASE_SCREEN_HEIGHT: 768,
};
